import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core'
import { assets, Category, Permission, PulseOpsFormat, SelectOption, SourceType, TableHeaderSort, TaskOp, TaskType, TransactionLabel, TransactionStatusLabel, TransactionType } from '@pulseops/common'
import { DrawerContentComponentProps, DrawerContentOptions } from '@react-navigation/drawer'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Pressable, StyleSheet, Text, TextStyle, TouchableOpacity, View } from 'react-native'
import { BasicSearchConst } from './BasicSearchConst'

export type BasicSearchTableProps = {
  rows: TaskOp[]
  setRows: (rows: TaskOp[]) => void
  roles: string[]
  parentNavigation: DrawerContentComponentProps<DrawerContentOptions>
  pageNum: number
  setPageNum: (pageNum: number) => void
  pageSize: number
  setPageSize: (pageSize: number) => void
  totalItem: number
  sortItem: { field: string; order: 'asc' | 'desc' | undefined }
  setSortItem: (sortItem: { field: string; order: 'asc' | 'desc' | undefined }) => void
  queryServiceInquiryList: (pageSize: number, pageNum: number) => void
  getCommentByTaskID: (processId: string) => void
  getServiceInquiryNoteByTaskID: (taskID: string) => void
  openUploadDocumentModal: (taskId: string, uploadImaging?: boolean) => void
  subServiceTypeList: SelectOption[]
  subTransactionTypeList: (SelectOption & { typeCode: string })[]
}
export const BasicSearchTable = (props: BasicSearchTableProps) => {
  const { t } = useTranslation()
  const classes = BasicSearchConst.makeBasicStyles()
  const {
    rows,
    setRows,
    roles,
    parentNavigation,
    pageNum,
    setPageNum,
    pageSize,
    setPageSize,
    totalItem,
    sortItem,
    setSortItem,
    queryServiceInquiryList,
    getCommentByTaskID,
    getServiceInquiryNoteByTaskID,
    openUploadDocumentModal,
    subServiceTypeList,
    subTransactionTypeList
  } = props

  const checkPressableCaseID = React.useCallback(
    (row: TaskOp) => {
      return (
        row.caseId &&
        roles.includes(Permission['ViewDetailServiceInquiry']) &&
        ((['PULSE4OPS', 'BANCA_SEA', 'LANDING_PAGE', 'PRUONLINE', 'ZALO', 'OUTBOUND', 'INBOUND', 'PRUSERVICES'].includes(row.source) &&
          (row.category !== TaskType.GENERAL ||
            (row.category === TaskType.GENERAL && row.transactionType === TransactionType.UPLOAD_DOCUMENT)) &&
          row.transactionType !== TransactionType.IMAGING_UPLOAD) ||
          (row.source === SourceType.PULSE &&
            ((row.policyNumber.length === 9 && row.transactionType === TransactionType.NEW_CLAIM_REGISTER) ||
              row.transactionType !== (TransactionType.UPLOAD_DOCUMENT && TransactionType.NEW_CLAIM_REGISTER))) ||
          (['EKIOSK', 'ZALO'].includes(row.source) &&
            [TransactionType.COMPLAINT, TransactionType.INQUIRY].includes(row.transactionType as TransactionType)) ||
          ([
            SourceType.PRUONLINE,
            SourceType.ONLINE_PAYMENT,
            SourceType.ShopeePay,
            SourceType.Ebanking_seabank,
            SourceType.MSB_BANK,
            SourceType.MOMO,
            SourceType.MOMO_FOR_AGENT,
            SourceType.MY_VIB,
            SourceType.Shopee,
            SourceType.PAYOO,
            SourceType.POS_SeABank,
            SourceType.VIB_AUTODEBIT,
            SourceType.Agribank_VBA,
            SourceType.Viettel,
            SourceType.VNPOST,
            SourceType.VIETTEL_TELCO,
            SourceType.MPOS_EXIMBANK,
            SourceType.Offline,
            SourceType.SACOMBANK,
            SourceType.CREDITLIFEPORTAL,
            SourceType.PRUSERVICES,
            SourceType.HSBC_BANK,
          ].includes(row.source as SourceType) &&
            BasicSearchConst.cashLessTransactions.includes(row.transactionType ?? '')))
      )
    },
    [roles]
  )


  const showCancelPaymentText = (value: string) => {
    return BasicSearchConst.cancelPaymentLabel.find((item) => item.value === value)?.label ?? '-'
  }

  const getServiceInquiryNote = (id: string) => {
    getServiceInquiryNoteByTaskID(id)
  }
  const showUploadDocument = (taskId: string, uploadImaging?: boolean) => {
    // setUploadDocVisible(true)
    // setUploadDocumentTaskId(taskId)
    // setIsUploadImaging(uploadImaging ?? false)
    openUploadDocumentModal(taskId, uploadImaging)
  }

  const getCommentById = (processId: string) => {
    getCommentByTaskID(processId)
  }

  return (
    <View style={basicStyle.container}>
      <TableContainer component={Paper} style={{ maxHeight: 500 }} elevation={1}>
        <Table style={{ userSelect: 'text' }} stickyHeader>
          <TableHead className={classes.tableHeader}>
            <TableHeaderSort
              data={rows}
              setData={setRows}
              sortItem={sortItem}
              setSortItem={setSortItem}
              column={[
                {
                  label: t('ServiceInquiry:table:CaseID'),
                  disabled: true,
                  field: 'caseId'
                },
                {
                  label: t('ServiceInquiry:table:Source'),
                  field: 'source'
                },
                {
                  label: t('ServiceInquiry:table:PolicyNumber'),
                  field: 'policyNumber'
                },
                {
                  label: t('ServiceInquiry:table:POClient'),
                  field: 'clientNumber'
                },
                {
                  label: t('ServiceInquiry:table:POID'),
                  field: 'poClientNumber'
                },
                {
                  label: t('ServiceInquiry:table:POName'),
                  field: 'poName'
                },
                {
                  label: t('ServiceInquiry:table:POPhoneNumber'),
                  field: 'poPhoneNumber'
                },
                {
                  label: t('ServiceInquiry:table:Category'),
                  field: 'categoryName'
                },
                {
                  label: t('ServiceInquiry:table:Service'),
                  field: 'service',
                  disabled: true
                },
                {
                  label: t('ServiceInquiry:table:Transaction'),
                  field: 'transactionTypeName'
                },
                {
                  label: t('ServiceInquiry:table:Group'),
                  field: 'group',
                  disabled: true
                },
                {
                  label: t('ServiceInquiry:table:SubService'),
                  field: 'subServiceTypeName'
                },
                {
                  label: t('ServiceInquiry:table:SubTransaction'),
                  field: 'subTransactionTypeName'
                },
                {
                  label: t('ServiceInquiry:table:UserSubmission'),
                  field: 'createdBy'
                },
                {
                  label: t('ServiceInquiry:table:CreatedDate'),
                  field: 'createdDate'
                },
                {
                  label: t('ServiceInquiry:table:LastAssignee'),
                  field: 'assigneeName'
                },
                {
                  label: t('ServiceInquiry:table:Aging'),
                  field: 'aging'
                },
                {
                  label: t('ServiceInquiry:table:LastUpdatedDate'),
                  field: 'lastUpdateDateVer'
                },
                {
                  label: t('ServiceInquiry:table:LastUpdatedBy'),
                  field: 'lastUpdateByVerName'
                },
                {
                  label: t('ServiceInquiry:table:CancelPaymentStatus'),
                  field: 'cancelPaymentStatus'
                },
                {
                  label: t('ServiceInquiry:table:Status'),
                  field: 'status'
                },
                {
                  label: t('ServiceInquiry:table:CurrentActivity'),
                  field: 'activity'
                },
                {
                  label: t('ServiceInquiry:table:BatchName'),
                  field: 'batchName'
                },
                {
                  label: t('ServiceInquiry:table:Note'),
                  field: 'note',
                  disabled: true
                },
                {
                  label: '',
                  field: '',
                  disabled: true
                }
              ]}
            />
          </TableHead>
          <TableBody>
            {rows.map((row, i) => {
              return (
                <TableRow
                  key={`TableRow-${i}`}
                  style={{ backgroundColor: row.suspendReasonPC === 'WRITE_OFF' ? '#ed1b2e26' : '#fff' }}
                >
                  {/* CaseID */}
                  <TableCell>
                    {checkPressableCaseID(row) ? (
                      <Pressable
                        onPress={() =>
                          parentNavigation.navigation.navigate('TaskDetailStack', {
                            screen: 'TaskDetailScreen',
                            params: {
                              id: row.id,
                              caterogy: row.category,
                              basket: '',
                              basketName: '',
                              isInquiry: '1',
                              isHistory: 'true',
                              isBreadcrumb: '1',
                              isPCWriteOff: row.suspendReasonPC === 'WRITE_OFF' ? 'true' : 'false',
                              hasArchivedHistoryView: '1'
                            }
                          })
                        }
                      >
                        <Text style={[{ color: '#ed1b2e' }, basicStyle.cellNoWrap]}>{row.caseId}</Text>
                      </Pressable>
                    ) : (
                      <Text style={basicStyle.cellNoWrap}>{row.caseId || '-'}</Text>
                    )}
                  </TableCell>
                  {/* Source */}
                  <TableCell>{row.source}</TableCell>
                  {/* PolicyNumber */}
                  <TableCell>{row.policyNumber || '-'}</TableCell>
                  {/* POClient */}
                  <TableCell>{row.clientNumber === 'null' ? '-' : row.clientNumber || '-'}</TableCell>
                  {/* POID */}
                  <TableCell>{row.poClientNumber || '-'}</TableCell>
                  {/* POName */}
                  <TableCell>{row.poName || '-'}</TableCell>
                  {/* POPhoneNumber */}
                  <TableCell>{row.poPhoneNumber || '-'}</TableCell>
                  {/* Category */}
                  <TableCell className={classes.cellNoWrap}>
                    {BasicSearchConst.convertCategoryToLabel(row.category) || '-'}
                  </TableCell>
                  {/* Service */}
                  <TableCell>{'-'}</TableCell>
                  {/* Transaction */}
                  <TableCell className={classes.cellNoWrap}>
                    {t(TransactionLabel(row.transactionType))}
                  </TableCell>
                  {/* Group */}
                  <TableCell>{'-'}</TableCell>
                  {/* SubService */}
                  <TableCell>
                    {subServiceTypeList.find((x) => x.value === row.subServiceType)?.label || '-'}
                  </TableCell>
                  {/* SubTransaction */}
                  <TableCell>
                    {subTransactionTypeList.find((x) => x.value === row.subTransactionType)?.label || '-'}
                  </TableCell>
                  {/* UserSubmission */}
                  <TableCell>{row.createdBy ? row.createdBy.split('@')[0] : '-'}</TableCell>
                  {/* CreatedDate */}
                  <TableCell>{PulseOpsFormat.datetoFormat(row.createdDate, 'DD/MM/YYYY HH:mm:ss')}</TableCell>
                  {/* LastAssignee */}
                  <TableCell>
                    <Text>{row.assigneeName || '-'}</Text>
                    {row.assignee && row.assignee !== '-' && (
                      <View>
                        <Text>({row.assignee.split('@')[0]})</Text>
                      </View>
                    )}
                  </TableCell>
                  {/* Aging */}
                  <TableCell>{row.aging}</TableCell>
                  {/* LastUpdatedDate */}
                  <TableCell>
                    {row.lastUpdateDateAdj
                      ? PulseOpsFormat.datetoFormat(row.lastUpdateDateAdj, 'DD/MM/YYYY HH:mm:ss')
                      : row.lastUpdateDateVer
                        ? PulseOpsFormat.datetoFormat(row.lastUpdateDateVer, 'DD/MM/YYYY HH:mm:ss')
                        : '-'}
                  </TableCell>
                  {/* LastUpdatedBy */}
                  <TableCell>
                    {row.lastUpdateByAdj
                      ? row.lastUpdateByAdj.split('@')[0]
                      : row.lastUpdateByVer
                        ? row.lastUpdateByVer.split('@')[0]
                        : '-'}
                  </TableCell>
                  {/* CancelPaymentStatus */}
                  <TableCell>
                    {row.cancelPaymentStatus ? showCancelPaymentText(row.cancelPaymentStatus) : '-'}
                  </TableCell>
                  {/* Status */}
                  <TableCell
                    style={{ color: TransactionStatusLabel(row.status).color }}
                    className={classes.cellNoWrap}
                  >
                    {TransactionStatusLabel(row.status).label}
                  </TableCell>
                  {/* CurrentActivity */}
                  <TableCell>{row.activity || '-'}</TableCell>
                  {/* BatchName */}
                  <TableCell>{row.batchName}</TableCell>
                  {/* Note */}
                  <TableCell>
                    {roles.includes(Permission['ViewNoteServiceInquiry']) &&
                      [Category.COMPLAINT, Category.INQUIRY].includes(row.category as Category) ? (
                      <TouchableOpacity onPress={() => getServiceInquiryNote(row.id)}>
                        <View style={basicStyle.btnDetail}>
                          <Text style={{ textAlign: 'center', color: '#0000ee' }}>{t('common:Detail')}</Text>
                        </View>
                      </TouchableOpacity>
                    ) : (row.transactionType === TransactionType.UPLOAD_DOCUMENT || row.transactionType === TransactionType.IMAGING_UPLOAD) ? (
                      <TouchableOpacity onPress={() => showUploadDocument(row.id, row.transactionType === TransactionType.IMAGING_UPLOAD)}>
                        <View style={basicStyle.btnDetail}>
                          <Text style={{ textAlign: 'center', color: '#0000ee' }}>{t('common:Detail')}</Text>
                        </View>
                      </TouchableOpacity>
                    ) : (
                      <Text> {'-'}</Text>
                    )}
                  </TableCell>
                  <TableCell>
                    <View>
                      <TouchableOpacity
                        onPress={() => {
                          getCommentById(row.id)
                        }}
                      >
                        <assets.IconComment />
                      </TouchableOpacity>
                    </View>
                  </TableCell>
                  {/* ClaimNumber */}
                  {/* <TableCell>{row.claimNumber || '-'}</TableCell> */}
                  {/* ClaimType */}
                </TableRow>
              )
            })}
            <TableRow></TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        page={pageNum}
        rowsPerPage={pageSize}
        count={totalItem}
        onPageChange={(e, page) => {
          setPageNum(page)
          queryServiceInquiryList(pageSize, page)
        }}
        onRowsPerPageChange={(e) => {
          setPageSize(Number(e.target.value))
          setPageNum(0)
          queryServiceInquiryList(Number(e.target.value), 0)
        }}
        labelRowsPerPage={t('common:PaginationSize')}
        labelDisplayedRows={({ from, to, count }) => t('common:Pagination', { from, to, count })}
        component={View}
      />
    </View>

  )
}
const basicStyle = StyleSheet.create({
  container: {
    marginLeft: 30,
    marginRight: 30,
    marginTop: 10
  },
  btnDetail: {
    width: 80,
    height: 40,
    backgroundColor: '#ebe9e9',
    borderRadius: 100,
    padding: 10
  },
  cellNoWrap: {
    whiteSpace: 'nowrap'
  } as TextStyle,
})